module.exports = __webpack_public_path__ + "static/media/logs.382762f2.svg";